// Translation review classification catalogs — exact labels per product spec.

export const ERROR_CATEGORIES = [
  { label: 'Accuracy', definition: 'Meaning is incorrect, incomplete, or added unnecessarily' },
  { label: 'Compliance', definition: 'Legal, regulatory, accessibility, or policy risk' },
  { label: 'Functional', definition: 'Breaks usability or technical structure' },
  { label: 'Language Quality', definition: 'Grammar, spelling, punctuation, or fluency issues' },
  { label: 'Linguistic Update', definition: 'Translation updated by reviewer without identifying a translation error' },
  { label: 'Source Content Issue', definition: 'Source text is ambiguous, incomplete, contradictory, or lacks necessary context to produce a reliable translation' },
  { label: 'Style and Tone', definition: 'Does not follow brand voice, plain language, or tú style' },
  { label: 'Terminology', definition: 'Incorrect or inconsistent use of approved terms' },
];

export const SEVERITIES = [
  { label: 'Critical', definition: 'Breaks compliance, meaning, or usability' },
  { label: 'Major', definition: 'Impacts meaning or user understanding' },
  { label: 'Minor', definition: 'Reduces quality but not meaning' },
  { label: 'Preferential', definition: 'Consistency or style improvement' },
  { label: 'Update(Non-Error)', definition: 'Reviewer update with no defect identified' },
];

export function getErrorCategoryDefinition(label) {
  return ERROR_CATEGORIES.find((c) => c.label === label)?.definition || '';
}

export function getSeverityDefinition(label) {
  return SEVERITIES.find((s) => s.label === label)?.definition || '';
}

/** Applied when approving unchanged AI text (no linguist edit). */
export const NO_EDIT_CLASSIFICATION = {
  error_category: 'Linguistic Update',
  severity: 'Update(Non-Error)',
};
